import {
  regexEmail,
  regexGreatherThanOne,
  regexGreatherThanZero,
  regexPassword,
  regexPhoneNumber,
  regexText,
} from "../../constants/regex";

export const emailValidator = (value) => {
  if (!regexEmail.test(value)) return "Pogrešna email adresa";
  return null;
};

export const passwordValidator = (value) => {
  if (!regexPassword.test(value)) return "Pogrešna lozinka";
  return null;
};

export const textValidator = (value) => {
  if (!regexText.test(value)) return "Pogrešan unos";
  return null;
};

export const greatherThanOneValidator = (value) => {
  if (!regexGreatherThanOne.test(value)) return "Pogrešan unos";
  return null;
};

export const greatherThanZeroValidator = (value) => {
  if (!regexGreatherThanZero.test(value)) return "Pogrešan unos";
  return null;
};

export const phoneNumberValidator = (value) => {
  if (!regexPhoneNumber.test(value)) return "Pogrešan unos";
  return null;
};
